function getOptionValue (configuration, optionKey) {
  const option = configuration && configuration[optionKey]
  return option && typeof option.value !== 'undefined' ? option.value : undefined
}

/**
 * Resolves which gallery/scrubber image index to show based on configuration.
 *
 * viewBindings: [{ index: 1, option: 'GTSeat', values: [2] }, ...]
 * First matching binding wins. Returns defaultIndex when nothing matches.
 */
export function resolveViewIndex (configuration, viewBindings, defaultIndex = 0) {
  if (!viewBindings || !configuration) {
    return defaultIndex
  }

  for (const binding of viewBindings) {
    const optionValue = getOptionValue(configuration, binding.option)
    const values = Array.isArray(binding.values)
      ? binding.values
      : [binding.values]

    if (values.includes(optionValue)) {
      return binding.index
    }
  }

  return defaultIndex
}

export function getViewBindingSnapshot (configuration, viewBindings) {
  if (!viewBindings || !configuration) {
    return ''
  }

  return viewBindings
    .map(
      binding =>
        binding.option + ':' + getOptionValue(configuration, binding.option)
    )
    .join('|')
}



// WEBPACK FOOTER //
// ./src/imageViewBindings.js